import { render, staticRenderFns } from "./RelatorioConsolidado.vue?vue&type=template&id=c10d8458&scoped=true&"
import script from "./RelatorioConsolidado.vue?vue&type=script&lang=js&"
export * from "./RelatorioConsolidado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10d8458",
  null
  
)

export default component.exports